import * as React from 'react';
import styled from 'styled-components';

import { ConnectionAddressObject } from '@origin-digital/address-lookup';

import { GreenOptions } from './green-options';
import { AddressOrPostcodeSelect } from './address-select';
import { EnergyTypes } from './energy-types';
import { breakpoints } from '../../../common/mediaQuery';

const FilterContainer = styled.div`
  padding: 0;
  display: flex;
  flex-direction: row;
  width: 100%;

  @media screen and (max-width: ${breakpoints.tablet}px) {
    flex-direction: column;
  }

  @media screen and (max-width: ${breakpoints.mobile}px) {
    padding: 0 16px;
  }
`;

const ResponsiveSection = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: ${breakpoints.mobile}px) {
    width: 100%;
    flex-direction: column;
  }
`;

interface FiltersProps {
  address?: ConnectionAddressObject;
  addressApiProps: {
    url: string;
    apiKey: string;
    qasAuthToken: string;
  };
  onAddressChange: (address?: ConnectionAddressObject, id?: string) => void;
  handleFuelRequirementChange: (which: string, selected: boolean) => void;
  requiresElectricity: boolean;
  requiresGas: boolean;
  disableElectricity: boolean;
  disableGas: boolean;
  handleHasSolarPanelsChange: (event) => void;
  hasSolarPanels: boolean;
  handlePostcodeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  postcode: string;
  handleRenewableEnergyChange: (which: string, value: number) => void;
  renewableEnergy: {
    gas: number;
    electricity: number;
  };
  lpgCrossSellLink: string;
  handleGasBottleLinkClick: (event: React.MouseEvent<any, MouseEvent>) => void;
  isBusiness: boolean;
}

export const Filters: React.FunctionComponent<FiltersProps> = ({
  address,
  addressApiProps,
  onAddressChange,
  handleFuelRequirementChange,
  requiresElectricity,
  requiresGas,
  disableElectricity,
  disableGas,
  handleHasSolarPanelsChange,
  hasSolarPanels,
  handlePostcodeChange,
  postcode,
  handleRenewableEnergyChange,
  renewableEnergy,
  lpgCrossSellLink,
  handleGasBottleLinkClick,
  isBusiness,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const addressId = urlParams.get('addressId');

  return (
    <FilterContainer id="cp-filter-container">
      <AddressOrPostcodeSelect
        onAddressChange={onAddressChange}
        addressApiProps={addressApiProps}
        handlePostcodeChange={handlePostcodeChange}
        postcode={postcode}
        address={address}
        addressId={addressId}
      />
      <ResponsiveSection>
        <EnergyTypes
          requiresElectricity={requiresElectricity}
          requiresGas={requiresGas}
          disableElectricity={disableElectricity}
          disableGas={disableGas}
          hasSolarPanels={hasSolarPanels}
          handleHasSolarPanelsChange={handleHasSolarPanelsChange}
          lpgCrossSellLink={lpgCrossSellLink}
          handleGasBottleLinkClick={handleGasBottleLinkClick}
          handleFuelRequirementChange={handleFuelRequirementChange}
        />
        <GreenOptions
          renewableEnergy={renewableEnergy}
          handleRenewableEnergyChange={handleRenewableEnergyChange}
          disableElectricity={disableElectricity || !requiresElectricity}
          disableGas={disableGas || !requiresGas}
          isBusiness={isBusiness}
        />
      </ResponsiveSection>
    </FilterContainer>
  );
};
